import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Spin } from "antd";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
// import Iconedit from '../../Images/Iconedit.png';
import { Upload, Icon, message, Form, Input } from "antd";
// import { Link } from "react-router-dom";
import companyLogo from "../../Images/companylogo.png";
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import AppConfigs from "../../Config/AppConfig";
import { update } from "../../api/Apis";
import { formatPhoneNumber, formatPhoneNumber1 } from "../commonFunctions";
import ChangePassword from "../../Components/ChangePassword";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import LocationAutocomplete from "../../Components/Autocomplete";
import ErrorPage from "../ErrorPage";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";

Amplify.configure(awsConfigure);

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

class ProfileSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadImgLoading: false,
      uploadCompanyLogoLoading: false,
      loading: false,
      visible: false,
      orgDetails: {},
      userDetails:JSON.parse(localStorage.getItem("userDetails")),
      profilePic: "",
      companyLogo: companyLogo,
      phoneEdit: false,
      addressEdit: false,
      selectedAddress: "",
      editMode: false,
    };
  }

  componentDidMount = () => {
    this.getUserData();
  };

  getUserData = async () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let profilePic = "",
      companyLogo = this.state.companyLogo;
    if (userDetails["profilePic"]) {
      profilePic = await Storage.get(userDetails["profilePic"]);
    }
    if (orgDetails["companyLogo"]) {
      companyLogo = await Storage.get(orgDetails["companyLogo"]);
    }
    this.setState({
      orgDetails: orgDetails,
      userDetails: userDetails,
      profilePic: profilePic,
      companyLogo: companyLogo,
      uploadImgLoading: false,
      uploadCompanyLogoLoading: false,
    });
  };

  handleChange = async (fileData) => {
    // e.preventDefault();
    this.setState({
      uploadImgLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let fileName = userDetails["id"] + "_profile_pic_" + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then((result) => {
      let data = {};
      data["entityData"] = {};
      data["entityData"]["profilePic"] = result.key;
      update(AppConfigs["entityNames"]["users"], userDetails["id"], data).then(
        async (result) => {
          if (result.success) {
            userDetails["profilePic"] = data["entityData"]["profilePic"];
            userDetails["profilePicPath"] = await Storage.get(
              data["entityData"]["profilePic"]
            );
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            window.location.reload();
            // this.getUserData();
          } else {
            this.setState({
              uploadImgLoading: false,
            });
            console.log(result.errors);
          }
        }
      );
    });
  };

  handleCompanyLogoChange = async (fileData) => {
    // e.preventDefault();
    this.setState({
      uploadCompanyLogoLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let fileName = orgDetails["id"] + "_company_logo_" + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then((result) => {
      let data = {};
      data["entityData"] = {};
      data["entityData"]["companyLogo"] = result.key;
      update(
        AppConfigs["entityNames"]["organizations"],
        orgDetails["id"],
        data
      ).then(async (result) => {
        if (result.success) {
          orgDetails["companyLogo"] = data["entityData"]["companyLogo"];
          localStorage.setItem("orgDetails", JSON.stringify(orgDetails));
          this.getUserData();
        } else {
          this.setState({
            uploadCompanyLogoLoading: false,
          });
          console.log(result.errors);
        }
      });
    });
  };
  phoneEdit = async () => {
    this.setState({
      phoneEdit: true,
    });
    const dataSource = this.state.userDetails;
    await this.props.form.setFieldsValue({
      phone: dataSource.phone,
    });
  };
  updatePhoneEdit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(["phone"], (err, values) => {
      if (!err) {
        this.setState({
          dataLoadingStatus: true,
        });

        let data = {};
        data["entityData"] = {};
        data["entityData"]["phone"] = values["phone"];
        let userDetails = JSON.parse(localStorage.getItem("userDetails"));

        update(
          AppConfigs["entityNames"]["users"],
          userDetails["id"],
          data
        ).then(async (result) => {
          if (result.success) {
            userDetails["phone"] = data["entityData"]["phone"];
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            this.setState({
              loading: false,
            });
            this.getUserData();
          } else {
            this.setState({
              loading: false,
            });
            console.log(result.errors);
          }
        });
        this.setState({
          phoneEdit: false,
        });
      }
    });
  };

  addressEdit = async () => {
    const dataSource = this.state.orgDetails;
    this.setState({
      addressEdit: true,
      selectedAddress: dataSource.address,
    });
    await this.props.form.setFieldsValue({
      address: dataSource.address,
    });
  };

  updateAddressEdit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(["address"], (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });

        let data = {};
        data["entityData"] = {};
        data["entityData"]["address"] = values["address"];
        data["entityData"]["latLangs"] = this.state.latLangs;
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        update(
          AppConfigs["entityNames"]["registrations"],
          orgDetails["id"],
          data
        ).then(async (result) => {
          if (result.success) {
            orgDetails["address"] = data["entityData"]["address"];
            localStorage.setItem("orgDetails", JSON.stringify(orgDetails));
            this.getUserData();
          } else {
            console.log(result.errors);
          }
        });
        this.setState({
          addressEdit: false,
        });
      }
    });
  };
  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    latLangs[fieldId] = latLng;
    this.setState({
      latLangs,
    });
  };

  render() {
    // const { visible, loading } = this.state;
    const { getFieldDecorator } = this.props.form;
    const uploadButton = (
      <div>
        <Icon
          style={{ fontSize: "30px", color: "#A2AABD" }}
          type={this.state.loading ? "loading" : "user"}
        />
      </div>
    );
    const imageUrl = this.state.profilePic;
    const props = {
      onChange: this.handleCompanyLogoChange,
      multiple: false,
    };
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (this.state.userDetails.userProfile !== "A"&&this.state.userDetails.userProfile !== "M") {
      return (
       <ErrorPage/>
      );
    }

    return (
      <div>
        <Row style={{ margin: "20px" }}>
          <Col lg={6} md={6} sm={24} xs={24}>
            <div
              style={{
                margin: "10px",
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "2%",
              }}
            >
              <Row
                style={{
                  borderBottom: "1px solid rgb(123 129 144 / 17%)",
                  paddingBottom: "10px",
                }}
              >
                <Col lg={12} md={12} sm={24} xs={24}>
                  <h4 className="Companyheadinglabel">Profile Details</h4>
                </Col>
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  style={{ textAlign: "right" }}
                >
                  {/* <Link style={{ color: 'red', textDecoration: 'underline', textAlign: 'right' }}><img src={Iconedit} alt={"Edit"} /></Link> */}
                </Col>
              </Row>
              <div className="profilesettings">
                <Spin spinning={this.state.uploadImgLoading}>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    style={{ borderRadius: "50%" }}
                    showUploadList={false}
                    // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    beforeUpload={beforeUpload}
                    onChange={this.handleChange}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="avatar"
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                </Spin>
              </div>
              <Col lg={24} md={24} sm={24} xs={24}>
                <h5
                  style={{
                    color: "black",
                    fontSize: "20px",
                    textAlign: "center",
                    paddingTop: "10px",
                    marginBottom: "0px",
                  }}
                >
                  {this.state.userDetails["firstName"] +
                    " " +
                    this.state.userDetails["lastName"]}
                </h5>
              </Col>
              {/* <h5 style={{ color: '#1A5EB9', fontSize: '17px', textAlign: 'center', paddingTop: '10px', marginBottom: '0px' }}>{this.state.userDetails["phone"]}</h5> */}
              <Col lg={24} md={24} sm={24} xs={24}>
                {this.state.phoneEdit === true ? (
                  <Row>
                    <Col lg={5} md={5} sm={24} xs={24} />
                    <Col
                      lg={15}
                      md={15}
                      sm={24}
                      xs={24}
                      style={{ marginBottom: "10px" }}
                    >
                      <Form.Item className="Formitem">
                        {getFieldDecorator("phone", {
                          rules: [
                            { required: true, message: "Please input Phone!" },
                            noWhitespaceRule,
                            notValidPhoneNumberRule
                          ],
                          initialValue: this.state.userDetails["phone"],
                        })(<Input style={{ height: "60px" }} />)}
                      </Form.Item>
                    </Col>
                    <Col lg={2} md={2} sm={24} xs={24}>
                      <CheckOutlined
                        title="update"
                        onClick={this.updatePhoneEdit}
                        style={{
                          fontSize: "1.5em",
                          float: "right",
                          color: "#006400",
                          marginTop: "20px",
                        }}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={24} xs={24}>
                      <CloseOutlined
                        title="Cancel"
                        onClick={() => {
                          this.setState({ phoneEdit: false });
                        }}
                        style={{
                          fontSize: "1.5em",
                          marginTop: "20px",
                          color: "red",
                          float: "right",
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col lg={22} md={22} sm={24} xs={24}>
                      <h3 style={{ marginLeft: "40%", color: "black" }}>
                        {this.state.userDetails &&
                        this.state.userDetails["phone"] &&
                        this.state.userDetails["phone"].length === 10
                          ? formatPhoneNumber(this.state.userDetails["phone"])
                          : formatPhoneNumber1(this.state.userDetails["phone"])}
                      </h3>
                    </Col>
                    <Col lg={2} md={2} sm={24} xs={24}>
                      <h3>
                        {
                          <EditOutlined
                            onClick={this.phoneEdit}
                            title="edit"
                            style={{ fontSize: "1.4em", float: "right" }}
                          />
                        }
                      </h3>
                    </Col>
                  </Row>
                )}
              </Col>
              <h5
                style={{
                  color: "#1A5EB9",
                  fontSize: "17px",
                  textAlign: "center",
                  paddingTop: "10px",
                  marginTop: "10px",
                }}
              >
                {this.state.userDetails["email"]}
              </h5>
              {/* <h5 style={{ color: '#24405E', fontSize: '17px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderBottom: '1px solid rgb(123 129 144 / 17%)' }}>{formatPhoneNumber(this.state.userDetails["phone"])}</h5> */}

              <div>
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Company Logo
                </h4>
                <Row>
                  <Col
                    lg={10}
                    md={10}
                    sm={24}
                    xs={24}
                    style={{ textAlign: "center" }}
                  >
                    <Spin spinning={this.state.uploadCompanyLogoLoading}>
                      <img
                        src={this.state.companyLogo}
                        style={{ width: "100px", height: "100px" }}
                        alt="logo"
                      />
                    </Spin>
                  </Col>
                  {userDetails && userDetails.userProfile !== "D" && (
                    <Col
                      lg={14}
                      md={14}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "auto", marginBottom: "auto" }}
                    >
                      <Upload {...props} fileList={this.state.fileList}>
                        <h4
                          style={{
                            color: "#1A5EB9",
                            fontSize: "13px",
                            marginTop: "30px",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          Update logo
                        </h4>
                      </Upload>
                    </Col>
                  )}
                </Row>
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Company Name
                </h4>
                <h2 style={{ color: "black", fontSize: "15px" }}>
                  {this.state.orgDetails["orgName"]}
                </h2>
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Address
                </h4>
                {this.state.addressEdit === true ? (
                  <Row>
                    <Col lg={22} md={22} sm={24} xs={24}>
                      {/* <h3 style={{float: 'left'}}>new Address</h3> */}
                      <Form.Item className="Formitem">
                        {getFieldDecorator("address", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Address",
                            },
                          ],
                        })(
                          <LocationAutocomplete
                            getAddress={(address, latLng) =>
                              this.getAddress(address, latLng, "address")
                            }
                            address={this.state.selectedAddress}
                            editMode={true}
                            setAddress={(address) => {
                              this.setState({ selectedAddress: address });
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                      <h3>
                        {
                          <CheckOutlined
                            onClick={this.updateAddressEdit}
                            title="edit"
                            style={{ fontSize: "1.4em", float: "right" }}
                          />
                        }
                      </h3>
                    </Col>
                    <Col lg={2} md={2} sm={24} xs={24}>
                      <CloseOutlined
                        title="Cancel"
                        onClick={() => {
                          this.setState({ addressEdit: false });
                        }}
                        style={{
                          fontSize: "1.5em",
                          marginTop: "20px",
                          color: "red",
                          float: "right",
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col lg={22} md={22} sm={24} xs={24}>
                      {/* <h3 style={{ float: 'left' }}>{this.state.orgDetails["address"] + ", " + this.state.orgDetails["cityCode"] + ", " + this.state.orgDetails["stateCode"]}</h3> */}
                      <h3 style={{ float: "left" }}>
                        {this.state.orgDetails["address"]}
                      </h3>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                      <h3>
                        {userDetails && userDetails.userProfile !== "D" && (
                          <EditOutlined
                            onClick={this.addressEdit}
                            title="edit"
                            style={{ fontSize: "1.4em", float: "right" }}
                          />
                        )}
                      </h3>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}>
            <div
              style={{
                margin: "10px",
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "2%",
              }}
            >
              <Row
                style={{
                  borderBottom: "1px solid rgb(123 129 144 / 17%)",
                  paddingBottom: "10px",
                }}
              >
                <Col lg={12} md={12} sm={24} xs={24}>
                  <h4 className="Companyheadinglabel">Security</h4>
                </Col>
              </Row>
              <Row style={{ textAlign: "center", paddingTop: "20px" }}>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <ChangePassword />
                </Col>
              </Row>
            </div>
          </Col>
          {/* <Col lg={6} md={6} sm={24} xs={24}>
            <div
              style={{
                margin: "10px",
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "2%",
                width: "600px",
                height:"670px"
              }}
            ></div>
          </Col> */}
        </Row>
      </div>
    );
  }
}

export default Form.create({ name: "profileSettings" })(
  withAppContext(withRouter(ProfileSettings))
);
